import React from 'react'

import { CtaDescriptionPosition, CtaDescriptionWidth } from '@constants/enums/cta'

interface CtaButtonContextValue {
  descriptionPosition: CtaDescriptionPosition
  descriptionWidth: CtaDescriptionWidth
  showCtaDescription: boolean
}

export const DefaultCtaButtonContext: CtaButtonContextValue = {
  descriptionPosition: CtaDescriptionPosition.Center,
  descriptionWidth: CtaDescriptionWidth.Auto,
  showCtaDescription: true,
}

export const CtaButtonContext = React.createContext<CtaButtonContextValue>(DefaultCtaButtonContext)

export const CtaButtonMetadataProvider = CtaButtonContext.Provider
